import { BillingFancyStatementsListComponent } from './statements-list/statements-list.component';
import { BillingFancyService } from './billing-fancy.service';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { WINDOW } from '@benefitsui/app/lib/tokens/window';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { BreadcrumbItem } from '@dxo/ng-swift-ui/lib/components/breadcrumbs-nav/breadcrumbs-nav.types';

@Component({
  selector: 'app-billing-fancy-page',
  templateUrl: './billing-fancy-page.component.html',
  styleUrls: ['./billing-fancy-page.component.scss'],
  standalone: false
})
export class BillingFancyPageComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(WINDOW) private window: Window,
    private BillingFancyService: BillingFancyService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  @ViewChild('listForm')
  private listForm!: BillingFancyStatementsListComponent;
  returnPath: string = "/benefits/billing-fancy/listing";
  currentPath: string = "/benefits/billing-fancy/billing";
  links: BreadcrumbItem[] = [];
  breadcrumbs: boolean = false;
  routeDataSubscription: Subscription = new Subscription();
  
  ngOnInit(): void {
    this.routeDataSubscription = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.breadcrumbs = this.resolveData('breadcrumbs');
      });
      this.links.push({
        text: this.route.routeConfig?.data?.headerText,
        path: this.returnPath
      });
  }

  ngOnDestroy(): void {
    this.routeDataSubscription?.unsubscribe();
  }


  navigateToChild(path: string) {
    this.router.navigate([path], {relativeTo: this.route, queryParamsHandling: "preserve"});            
    this.scrollToTop();    
  }

  scrollToTop() {
    this.window.scrollTo(0, 0);
  }

 
  private resolveData(key: string) {
    let child = this.route.firstChild;
    while (child) {
      if (child.firstChild) {
        child = child.firstChild;
      } else if (child.snapshot.data && child.snapshot.data[key]) {
        return child.snapshot.data[key];
      } else {
        return undefined;
      }
    }
  }
}
